var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chart-wrapper" },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.labels
        ? _c(
            "div",
            { staticClass: "flexRowWrap flexRowJustifyCenter marginT-32" },
            _vm._l(_vm.labels, function(label, index) {
              return _c(
                "div",
                { key: index, staticClass: "flexRowAlignCenter padding-5-12" },
                [
                  _c("div", {
                    style: {
                      backgroundColor: label.color
                        ? label.color
                        : _vm.colors[index],
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      marginRight: "8px"
                    }
                  }),
                  _vm._v(" "),
                  _c("h6", { staticClass: "lineHeight-100 marginB0" }, [
                    _vm._v(_vm._s(label.name ? label.name : label))
                  ])
                ]
              )
            }),
            0
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8b22896", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8b22896","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/charts/ChartLegendWrap.vue
// module id = 1786
// module chunks = 0